/* global axios */

import ApiClient from './ApiClient';

class PostSaleDeedFeedbackAPI extends ApiClient {
  constructor() {
    super('post_sale_deed_feedback', { accountScoped: true });
  }

  pending() {
    return axios.get(`${this.url}/pending`);
  }

  questions() {
    return axios.get(`${this.url}/questions`);
  }

  upload(postSaleCaseId, file, onUploadProgress) {
    const formData = new FormData();
    formData.append('post_sale_case_id', postSaleCaseId);
    formData.append('file', file);
    return axios.post(`${this.url}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
  }

  submit(postSaleCaseId, responses, idempotencyKey) {
    return axios.post(
      this.url,
      { post_sale_case_id: postSaleCaseId, responses },
      { headers: { 'Idempotency-Key': idempotencyKey } }
    );
  }
}

export default new PostSaleDeedFeedbackAPI();
